import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import { take, map } from 'rxjs/operators';
import { UserProfile } from 'src/app/modules/core/store/user-profile';
import { OrgBusinessUnit } from '../org-business-units';
import { interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  constructor(private store: Store<any>) {}

  getUserProfile(): UserProfile {
    let userProfile: UserProfile = null;
    this.store
      .select(fromUserProfile.selectProfileUser)
      .pipe(
        take(1),
        map(value => {
          userProfile = value;
        })
      )
      .subscribe();

    return userProfile;
  }

  getUserHasBusinessUnits(): boolean {
    let hasBusinessUnits: boolean = false;
    this.store
      .select(fromUserProfile.selectUserHasBusinessUnits)
      .pipe(
        take(1),
        map(value => {
          hasBusinessUnits = value;
        })
      )
      .subscribe();

    return hasBusinessUnits;
  }

  getUserBusinessUnits(): OrgBusinessUnit[] {
    let units: OrgBusinessUnit[] = null;
    this.store
      .select(fromUserProfile.selectUserBusinessUnits)
      .pipe(
        take(1),
        map(value => {
          units = value;
        })
      )
      .subscribe();

    return units;
  }
}

